import * as StoreUtils from "../../utils/StoreUtils";
import {
	UPDATE_TEXTS,
	UPDATE_TEXT,
	REMOVE_TEXTS,
} from "../constants/ActionConstants";

export function updateTexts(updates) {
	StoreUtils.getStore().dispatch(_updateTexts(updates));
}

function _updateTexts(items) {
	return (dispatch: (action) => void) => {
		dispatch({ items, type: UPDATE_TEXTS });
	};
}

export function updateText(id, updates = {}) {
	StoreUtils.getStore().dispatch(_updateText(Object.assign(updates, { id })));
}

function _updateText(item) {
	return (dispatch: (action) => void) => {
		dispatch({ item, type: UPDATE_TEXT });
	};
}

export function removeTexts(ids) {
	StoreUtils.getStore().dispatch(_removeTexts({ ids }));
}

function _removeTexts(item) {
	return (dispatch: (action) => void) => {
		dispatch({ item, type: REMOVE_TEXTS });
	};
}
